import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { FieldsetBox, LegendStyled } from '../styling/StyledComponents';

export default function OutputType(props) {
  const { userParams, setUserParams } = props;

  const handleCheckboxChange = (event) => {
    const name = event.target.name;
		const checked = event.target.checked;
    const outputOptions = {...userParams.output, [name]: checked};
    setUserParams({...userParams, output:outputOptions})
  }

  return (
    <FieldsetBox component="fieldset" sx={{ mt: 1 }}>
      <LegendStyled>Output options</LegendStyled>
      <FormGroup row>
        { Object.keys(userParams.output).map((opt, i) => (
            <FormControlLabel
                key={i}
                control={
                    <Checkbox checked={userParams.output[opt]} name={opt} sx={{ py: 0 }} onChange={handleCheckboxChange} />
                }
                label={opt.charAt(0).toUpperCase() + opt.slice(1).replace("_"," ")}
            />
        ))}
      </FormGroup>
    </FieldsetBox>
  )
}